@if (ability.can('read-sales-spec-lots', 'spec-lots')) {
  <div class="d-flex flex-column h-100 gap-3">
    @if (!showDetails()) {
      <div class="flex-fill h-100">
        <div class="d-flex flex-column gap-3 h-100">
          <ng-container extra-actions>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-3">
                <generic-dropdown
                  [items]="projectsDropdownData()"
                  [label]="'Project'"
                  [placeholder]="'Select Project'"
                  [required]="false"
                  [allowSearch]="true"
                  [clearable]="true"
                  [formControl]="projectControl"
                >
                </generic-dropdown>
              </div>
            </div>
          </ng-container>
          <div class="flex-fill h-100 overflow-hidden">
            @if (!hasProjectSelected()) {
              <div class="d-flex align-items-center justify-content-center h-100 bg-gray-100 rounded-4">
                <div class="text-center text-muted">
                  <i class="bi bi-folder lh-1 fs-48 mb-3 d-block"></i>
                  <h3 class="mb-2">No Results Found</h3>
                  <p class="mb-0 fs-16">
                    Please select a project from the dropdown above to view build spec and models.
                  </p>
                </div>
              </div>
            } @else if (showNoResultsMessage()) {
              <div class="d-flex align-items-center justify-content-center h-100 bg-gray-100 rounded-4">
                <div class="text-center text-muted">
                  <i class="bi bi-folder lh-1 fs-72 mb-3 d-block"></i>
                  <h3 class="mb-2">No Results Found</h3>
                  <p class="mb-0 fs-16">No spec lots match your search criteria. Try a different search term.</p>
                </div>
              </div>
            } @else if (hasSpecLots()) {
              <app-build-spec-models-table
                [specLots]="specLots()"
                (rowClick)="onRowClick($event)"
              ></app-build-spec-models-table>
            } @else {
              <div class="d-flex align-items-center justify-content-center h-100 bg-gray-100 rounded-4">
                <div class="text-center text-muted">
                  <i class="bi bi-folder lh-1 fs-72 mb-3 d-block"></i>
                  <h3 class="mb-2">No Data Available</h3>
                  <p class="mb-0 fs-16">No spec lots found for the selected project.</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="flex-fill h-100">
        <app-build-spec-models-details
          [specLot]="selectedSpecLot()!"
          (close)="closeDetails()"
        ></app-build-spec-models-details>
      </div>
    }
  </div>
}
